var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCoffee = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91266 23.8351C3.06575 23.8351 0 21.2228 0 17.0991V3.48675C0 1.21982 3.75662 0 8.97056 0C14.1953 0 17.9519 1.21982 17.9519 3.48675V5.85083H18.578C20.6614 5.85083 22 7.24338 22 9.35918V13.6879C22 15.8145 20.6614 17.1963 18.578 17.1963H17.9519C17.8979 21.2552 14.843 23.8351 10.0285 23.8351H7.91266ZM8.97056 4.03729C12.738 4.03729 15.3503 3.61629 15.3503 3.01178C15.3503 2.40726 12.738 1.98626 8.97056 1.98626C5.21394 1.98626 2.59078 2.40726 2.59078 3.01178C2.59078 3.61629 5.21394 4.03729 8.97056 4.03729ZM7.91266 21.7085H10.0285C13.6016 21.7085 15.8253 19.9382 15.8253 17.0991V5.18155C14.3464 5.77527 11.8312 6.05594 8.97056 6.05594C6.12071 6.05594 3.6055 5.77527 2.12659 5.18155V17.0991C2.12659 19.9382 4.35034 21.7085 7.91266 21.7085ZM18.578 7.93425H17.9519V15.1129H18.578C19.4956 15.1129 19.9166 14.6811 19.9166 13.6879V9.35918C19.9166 8.37684 19.4956 7.93425 18.578 7.93425Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCoffee, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/coffee.c258be8d.svg";
export { ForwardRef as ReactComponent };